import React from 'react';

const Education = () => {
    return(
        <>
            <section>
                <h1 className='component-title'> My Journey at FCAI </h1>
                <section className='Container m-auto'>
                    <h1> Bachelor’s Degree in Artificial Intelligence </h1>
                    <div>
                        <h5> Artificial Intelligence Department at Faculty of Computers and Artificial Intelligence, Cairo University </h5>
                        <h5> 📍 Cairo, Egypt </h5>
                        <h5> 📅 2019 – 2025  </h5>
                        <section style={{"text-align":"left"}}>
                            <h5> 🧠 Overview </h5>
                            <span> Specialized in software engineering and intelligent systems, combining academic excellence with real-world AI applications. The program provided a comprehensive foundation in Machine Learning, Deep Learning, NLP, and Computer Vision alongside full-stack development practices. </span>
                            <hr/>
                            <h5>📘 Education</h5>
                            <dl>
                                <dt><strong>Core Focus Areas:</strong></dt>
                                <dd>
                                <ul>
                                    <li>Machine Learning</li>
                                    <li> Deep Learning </li>
                                    <li>Natural Language Processing (NLP)</li>
                                    <li>Computer Vision & Image Processing</li>
                                    <li>Data Structures & Algorithms</li>
                                    <li>Software Engineering & System Design</li>
                                    <li>Databases (SQL, NoSQL)</li>
                                    <li>Operating Systems & Networking</li>
                                    <li>Web & API Development</li>
                                    <li> OOP & Design Principles </li>
                                    <li> Mathematics - Calucus </li>
                                    <li> Mathematics - Linear Algebra </li>
                                    <li> Discrete Mathematics </li>
                                </ul>
                                </dd>
                            </dl>
                            <hr/>
                            <h5> 🎓 Graduation Project: </h5>
                            <span> <strong>SumGenQ – AI-Based Summarization System</strong><br/> Developed a smart document summarizer that uses OCR, NLP, and deep learning models. The system takes in images, PDFs, and raw text, and outputs clean summaries and quiz questions using BART and LoRA fine-tuning techniques. </span>
                        </section>
                    </div>
                </section>
            </section>
        </>
    )
}

export default Education;